import json from "../json/billingAccountsJfrogaccSubscriptionsJfrogaccRenewalDate.json";

export default async () => JSON.parse(JSON.stringify(await json));
